// French (fr-CA) names for calculators and categories, used in the nav dropdown,
// footer and calculator pages. English values come from src/data/calculators.ts;
// these override them when the locale is French.
import type { Locale } from './locale'

export const CALC_FR: Record<string, { name: string; short: string; tagline: string }> = {
  paint: { name: 'Calculateur de peinture', short: 'Peinture', tagline: 'Combien de peinture me faut-il?' },
  drywall: { name: 'Calculateur de gypse', short: 'Gypse', tagline: 'Feuilles, composé, ruban et vis.' },
  wallpaper: { name: 'Calculateur de papier peint', short: 'Papier peint', tagline: 'Rouleaux avec raccord de motif.' },
  flooring: { name: 'Calculateur de plancher', short: 'Plancher', tagline: 'Bois franc, stratifié et vinyle.' },
  tile: { name: 'Calculateur de carrelage', short: 'Carrelage', tagline: 'Tuiles, coulis, mortier et croisillons.' },
  concrete: { name: 'Calculateur de béton', short: 'Béton', tagline: 'Dalles, semelles et trous de poteau.' },
  gravel: { name: 'Calculateur de gravier', short: 'Gravier', tagline: 'Granulat par surface, profondeur et tonnes.' },
  deck: { name: 'Calculateur de terrasse', short: 'Terrasse', tagline: 'Planches, solives, vis et semelles.' },
  fence: { name: 'Calculateur de clôture', short: 'Clôture', tagline: 'Poteaux, lisses, planches et béton.' },
  mulch: { name: 'Calculateur de paillis', short: 'Paillis', tagline: 'Sacs ou verges cubes en vrac.' },
  roofing: { name: 'Calculateur de toiture', short: 'Toiture', tagline: 'Carrés, paquets et sous-couche.' },
  insulation: { name: 'Calculateur d’isolation', short: 'Isolation', tagline: 'Matelas et rouleaux par valeur R.' },
  // New calcs — EN only for the lean MVP. Falls back to English fallback name via calcName/short/tagline.
  'roof-pitch': { name: 'Roof Pitch Calculator', short: 'Roof Pitch', tagline: 'Rafter length, rise, angle & slope factor.' },
  stair: { name: 'Stair Calculator', short: 'Stairs', tagline: 'Risers, treads, stringer & IRC code check.' },
  'sheet-cut': { name: 'Sheet Cut Calculator', short: 'Sheet Cut', tagline: 'Plywood cut layout & sheets needed.' },
  dimensions: { name: 'Dimensions Converter', short: 'Dimensions', tagline: 'Length, area & volume across units.' },
  lumber: { name: 'Lumber & Framing Calculator', short: 'Lumber', tagline: 'Stud count, plates, headers & nails for any wall.' },
}

export const CATEGORY_FR: Record<string, { name: string; blurb: string }> = {
  'paint-and-walls': { name: 'Peinture et murs', blurb: 'Peinture, gypse et papier peint pour toute pièce.' },
  'flooring-and-tile': { name: 'Planchers et carrelage', blurb: 'Quantités de plancher et de carrelage, avec les matériaux de pose.' },
  'concrete-and-aggregate': { name: 'Béton et granulats', blurb: 'Béton, gravier et les matériaux qui les accompagnent.' },
  'outdoor-and-landscaping': { name: 'Extérieur et aménagement', blurb: 'Terrasses, clôtures et paillis pour vos projets extérieurs.' },
  'roofing-and-insulation': { name: 'Toiture et isolation', blurb: 'Couverture de toiture et d’isolation selon la surface et le climat.' },
}

export function calcShort(slug: string, fallback: string, locale: Locale): string {
  return locale === 'fr' ? CALC_FR[slug]?.short ?? fallback : fallback
}
export function calcName(slug: string, fallback: string, locale: Locale): string {
  return locale === 'fr' ? CALC_FR[slug]?.name ?? fallback : fallback
}
export function calcTagline(slug: string, fallback: string, locale: Locale): string {
  return locale === 'fr' ? CALC_FR[slug]?.tagline ?? fallback : fallback
}
export function categoryName(slug: string, fallback: string, locale: Locale): string {
  return locale === 'fr' ? CATEGORY_FR[slug]?.name ?? fallback : fallback
}
